import enLocale from 'element-ui/lib/locale/lang/en'

const en = {
  message: {
    message: 'I have read and agree',
    agree: 'The service agreement',
    
    hello: 'hello',
    lang: 'English',
    accoPlaceholder: 'Usename/Phonenumber',
    passPlaceholder: 'Password',
    loginBtnText: 'Login',
    logOutText: 'log-out',
    
    menuText: {
      custManageTitle: 'custManage',
      addManageText: 'addresManage',
      orderManageTitle: 'orderManage',
      ordercheckTitle: 'ordercheck',
      signatureFormTitle: 'signManage',
      deliverymanTitle: 'deliveryManage',
      deliveryDetailTitle: 'deliveryDetail',
      distributionStatisticsTitle: 'deliveryStatistic',
      deliveryClockStatisticsTitle: 'deliveryClockStatistics',
      temporaryWorkersTitle: 'temporaryManage',
      clockStatisticsTitle: 'clockInStatistics',
      containerTitle: 'ORDER',
      containerQueryTitle: 'Order Tracking',
      historyOrdersTitle: 'Order history',
      formalWorkersTitle: 'Regular staff',
      reservedCargoManagement: '保留貨物管理',
      amazonOrderTitle: 'ContainerOrderDetails',
			orderRecycleBinTitle:'Recycle Bin',
    },
    
    custManageText: 'custManage',
    addManageText: 'addresManage',
    custSearchPlaceholder1: 'Customer name/login name',
    custSearchPlaceholder: 'Customer name',
    searchBtnText: 'search',
    addCustBtnText: 'new customer',
    updateCustBtnText: 'Modify the customer',
    customTableTitle1: 'Serial number',
    customTableTitle2: 'Customer name',
    customTableTitle3: 'Password',
    customTableTitle4: 'Rights management',
    customTableTitle5: 'operation',
		customTableTitle6: 'add to SKU',
		addFileFBA: 'add to FBA',

    customTableContent: 'check',
    cancleText: 'cancle',
    confirmText: 'confirm',
    newCustomerName: 'Customer name',
    newCustomerLoginName: 'Customer login name',
    newCustomerPhone: 'Customer mobile',
    newCustomerSpecial: 'Special template',
    newCustomerPassword: 'Customer password',
    newCustomerCompany: 'Client company',
    newCustomerEmail: 'Email',
    newCustomerProvince: 'Province',
    newCustomerCity: 'Town',
    newCustomerDetailAddress: 'Detailed address',
    newCustomerPermission: 'permissions',
    newCustomerIsAdmin: 'Administrator rights',
		newCustomerIsDriverAdmin: 'Administrator driver',
		newCustomerIsDriverPosition: 'Transportatins manager',
		createClockInfo:'record the time',
		createClockDutyInfo: '勤務日外打刻追加',
		clockTimeInfoTitle:'clock-in time',
		clockPlaceInfoTitle:'clock-in place',
		
		tokyoOffice:'Tokyo pick up request',
		osakaOffice:'Osaka pick up request',
		
		
		IsSiJi: '是否司机',
		IsExternalSiJi: '外部司机',
		selectTokyo:'Tokyo',
		selectYokohama:'Yokohama',
		selectOsaka:'Osaka',
		selectNagoya:'Nagoya',
		selectKobe:'Kobe',
		selectOther:'Other',
		
    //正式员工管理
    EmployeeNo:'员工编号',
    BusinessOffice:'营业所',
		
		
		
    placeholder: 'please input',
    permission: [{
      pkid: 'F00',
      label: 'Customer management',
    }, {
      pkid: 'F01',
      label: 'Address management',
    }, {
      pkid: 'F02',
      label: 'Order management',
    }, {
      pkid: 'F03',
      label: 'Order View',
    }, {
      pkid: 'F04',
      label: 'Sign receipt management',
    }, {
      pkid: 'F05',
      label: 'Distributor management',
    }, {
      pkid: 'F06',
      label: 'Delivery detail',
    }, {
      pkid: 'F07',
      label: 'Distribution statistics',
    }, {
      pkid: 'F08',
      label: 'Temporary management',
    }, {
      pkid: 'F09',
      label: 'ORDER',
    }, {
      pkid: 'F10',
      label: 'Order Tracking'
    }, {
      pkid: 'F11',
      label: 'Order history'
    }, {
      pkid: 'F12',
      label: 'Regular staff'
    }, {
      pkid: 'F13',
      label: '保留貨物管理'
    }, {
      pkid: 'F14',
      label: 'Container order details'
    }, {
      pkid: 'F15',
      label: '配車管理'
    }, {
			pkid: 'F16',
			label: 'Recycle Bin'
		}],
    prompt: 'This action will permanently delete the customer. Do you want to continue?',
    promptTitle: 'prompt',
    addressNameTitle: 'Customer name',
    addressPhoneTitle: 'Customer mobile',
    addresseeNameTitle: 'Name of addressee',
    addresseePhoneTitle: 'Recipient mobile',
    provienceAddressTitle: 'County/province',
    cityAddressTitle: 'city',
    detailAddressTitle: 'detail-address',
    addresseeAddressTitle: 'Addressee address',
    addressAddNameTitle: 'Add person name',
    addressAddTimeTitle: 'Add time',
    addAddresseeBtnText: 'New address',
    updateAddresseeBtnText: 'Modify the address',
    addresseePrompt: 'This action will permanently delete the customer address. Do you want to continue?',
    canclePrompt: 'Cancel deletion',
    
    orderSearchPlaceholder: 'Please enter the order number',
    orderSearchPlaceholder2: 'Please enter the name of sender/receiver',
    orderStatusList: [{ value: 0, label: 'In transit' }, { value: 1, label: 'In distribution' }, { value: 2, label: 'Signed in' }, { value: 3, label: 'Been cancelled' }],
    orderTimeStartHolder: 'start time',
    orderTimeEndHolder: 'end time',
    orderSearchPlaceholder3: 'please select province',
    orderSearchPlaceholder4: 'Please enter remarks',
    addOrderBtnText: 'new orders',
    updateOrderBtnText: 'modify order',
    orderTableTitle1: 'order number',
    orderTableTitle2: 'bar code',
    orderTableTitle3: 'Transportation',
    orderTableTitle4: 'Name of sending company',
    orderTableTitle5: 'name of sender',
    orderTableTitle6: 'contact number',
    orderTableTitle7: 'Number of items',
    orderTableTitle8: 'Item weighing',
    orderTableTitle9: 'Item volume',
    orderTableTitle10: 'Order status',
    orderTableTitle11: 'Creation time',
    orderState0: 'In transit',
    orderState1: 'In distribution',
    orderState2: 'Signed in',
    orderState3: 'Been cancelled',
    orderTableCheckTitle: 'check',
    senderPhoneTitle: 'Sender mobile',
    senderEmailTitle: 'Sender email',
    senderProvienceTitle: 'Mailing province / City',
    senderCityTitle: 'Mailing City',
    senderAddressTitle: 'Mailing address',
    addresseeInfoTitle: 'Recipient information',
    addresseeProvienceTitle: 'Receiving province / City',
    addresseeCityTitle: 'Mailing City / county',
    addresseeTitle: 'Receiving address',
    addresseeCompanyTitle: 'Name of receiving company',
    addresseeNameTitle: 'Recipient name',
    addresseePhoneTitle: 'Recipient phone',
    addresseeEamilTitle: 'Recipient email',
    orderRemarkTitle: 'Cargo number',

    orderPrompt: 'This action will permanently delete the order. Do you want to continue?',
    orderCanclePrompt: 'This action will permanently invalidate the order. Do you wish to continue?',
    downLoadExcel: 'Download the template',
    importExcelTitle: 'import Excel',
    selectExcel: 'Select the file',
    importExcelError: 'File upload failed',
    importExcelCheck: 'View the import file',
    confirmImportExcel: 'Make sure the import',
    setOrdersContainer: 'Set up container',
    delOrderText: 'Delete',
		savesOrderText: 'Saves',

    
    backText: 'Return',
    addNewLogisticsText: 'New logistics information',
    updateLogisticsText: 'Modify logistics information',
    goodsStatusTitle: 'Cargo status',
    deliveryStatusTitle: 'Delivery status',
    positionTitle: 'Reach location',
    logisticsImgTitle: 'Logistics picture',
    dateTitle: 'date',
    uploadLogisticsImg: 'Upload pictures',
    logisticsPrompt: 'This operation will permanently delete the logistics information. Do you want to continue?',
    startLogistics: 'Began to delivery',
    endlogistics: 'Complete the delivery',
    orderHasCompleteText: 'Confirm that the order has been completed',
    
    signatureSearchPlaceholder: 'Please enter the name of the receipt',
    signatureSearchPlaceholder2: 'Please enter the receipt number',
    addSignatureBtnText: 'New receipt',
    signatureFormName: 'Name of receipt',
    signatureNumTitle: 'Bill no',
    signatureOrderTitle: 'order',
    signatureOrderImgTitle: 'picture',
    signatureStateTitle: 'state',
    signatureAddUserTitle: 'founder',
    signatureAddTimeTitle: 'Creation time',
    signaturePrompt: 'This action will permanently delete the receipt information. Do you want to continue?',
    signatureNotOrder: 'add',
    signatureHasOrder: 'check',
    signatureStatusTitle1: 'ongoing',
    signatureStatusTitle2: 'completed',
    signatureInsertOrderSearchPlaceholder: 'Please enter the keyword',
    signatureInsertOrderText: 'Add the order',
    signatureInsertImgText: 'Add photos',
    signatureInsertTipsText: 'Please select the order',
    signatureInsertPrompt: 'Whether to join the order',
    uploadImgErrorFormatText: 'Upload pictures in JPG format only!',
    uploadImgErrorTipsText: 'Picture upload failed, please try again',
    uploadImgNoImgTitle: 'Please select pictures to upload',
    signatureInsertImgPrompt: 'Whether to add pictures or not',
    endSignatureTitle: 'Whether the receipt is completed?',
    signOrderTitleText: 'Sign the receipt order',
    
    deliveryAreaTitle: 'Please select the distribution range',
    addDeliveryManTitle: 'Additional distributors',
    updateDeliveryManTitle: 'Modify distributor',
    deliveryAccountTitle: 'Login account',
    deliveryNameTitle: 'Name of distributor',
    deliveryPasswordTitle: 'Login password',
    deliveryAreaTitle: 'Scope of delivery',
    deliveryPhoneTitle: 'Mobile',
    deliveryEmailTitle: 'mail',
    delDeliveryPrompt: 'This action will permanently delete the deliverer. Do you want to continue?',
    
    deliveryManTitle: 'delivery man',
    deliveryTimeTitle: 'delivery time',
    deliveryNumTitle: 'shipping number',
    exportText: 'export',
    
    tempeoraryNameTitle: 'Name of temporary employee',
    attendanceTimeTitle: 'Attendance time',
    addTempeoraryManTitle: 'New temporary staff',
    updateTempeoraryManTitle: 'Modification of temporary staff',
    todayClockNum: 'Number of people clocking in today',
    tempeoraryNameTitle: 'Name',
    tempeoraryPhoneTitle: 'Mobile phone no',
    tempeoraryEmailTitle: 'Email',
    tempeoraryAccountTitle: 'Account',
    tempeoraryPasswordTitle: 'Password',
    airportWageTitle: 'Airport transportation',
    warehouseWageTitle: 'Warehouse the trip',
    dailyWageTitle: 'Monthly subsidy ceiling',
    hourlyWageTitle: 'Hourly wage',
    monthlyPassTitle: 'Transportation monthly pass',
    attendanceNumTitle: 'Total number of attendance',
    attendanceHoursTitle: 'Total hours of attendance',
    clockInDetailTitle: 'Clock in detail',
    delTempeoraryPeompt: 'This action will permanently delete the temporary employee. Do you want to continue?',
    clockInAddTitle: 'Clock in place',
    punchInTimeTitle: 'Time to punch in',
    punchOutTimeTitle: 'Punch out time',
    manHourTitle: 'Working hours',
    strippingStartTime: 'Tear open tank start time',
    strippingEndTime: 'Tear open tank end time',
    strippingSize: 'Tear open tank size',
    strippingNum: 'Tear open ark number',
    littleSize: 'Small size',
    bigSize: 'Large size',
		
		trailerArrangement:'Arranging drayage',
		containerTransportWays1:'Arranging drayage and Devanning by JHSS',
		containerTransportWays2:'Only Devanning by JHSS',
		containerTransportWays3:'Only Arranging drayage by JHSS-',

    
    containerTitle: 'Order information',
    week: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
    noEnterContainersNum: 'Number of containers not entered',
    newContainerTitle: 'Creating Orders',
    modifyContainerTitle: 'Change orders',
    // containerOrderCity: 'CITY',
    containerOrderCity: 'CITY',
    containerJOBNO: 'Job no',
    containerCreater: 'Undertaker',
    containerOrderModel: 'Cargo Type',
    containerGoodsModel: 'Cargo Type',
    litijin: '立替金',
    containerText: 'container',
    containerOrderNumber: 'Container number',
    placeOfDelivery: 'Pick-up point',
    containerOrderArrivalDate: 'Operating time',
    containerStripping: 'Container unpacking time',
    deliveryDate: 'Specified time',
    hasSpecifyTime: 'have',
    noSpecifyTime: 'not have',
    specifyTime: ' Specified time',
    containerOrderCustomerID: 'Customer ID',
    containerOrderCustomer: 'Guest',
    customerDedicatedNum: 'Guest special number',
    containerOrderNum: 'Number',
    containerOrderVolume: 'Volume',
    containerOrderWeight: 'Weight',
    containerOrderRemark: 'remarks',
    containerOrderAttacherFile: 'additional documents',
    addFileText: 'Add files',
    noAttachment: 'No attached files',
    goodsStatus: 'Condition of goods',
    setGoodsStatus: 'set',
    hasArrive: 'Have reached',
    notArrive: 'Did not arrive',
    containerCondition: 'abnormal/normal',
    conditionAbnormal: 'Whether the abnormal',
    normalCondition: 'normal',
    abnormalCondition: 'abnormal',
    adnormalRemark: 'Exception description',
    abnormalUpload: 'Abnormal situation upload',
    exportDatePlaceholder: 'Please select',
    kantoReceipt: 'Kanto sign receipt',
    kansaiReceipt: 'Kansai sign receipt',
    containerReceipt: 'receipt form',
    containerReturnReceipt: 'Return receipt',
    FBASKUtally: 'FBA/SKU label',
    billTitle: 'Bill',
    uploadReceipt: 'Upload files',
    sendEmailPeompt: 'Whether to send email or not?',
    containerOrdersDetails: 'Order details',
    numberUnitPlaceholder: 'Please fill in the unit of quantity!',
    downloadNumber: 'download count',
    download: 'download files',
		downloadCode: 'download QR code',

    affirmText: 'Confirm',
    confirmPeople: 'Confirm people',
    affirmTime: 'Affirm Time',
    remarkFillSuccess: 'Note Completion',
		SKUInfoFillSuccess: 'SKU Completion',

    tallyName: 'Tag Name',
    cancelAffirmText: 'cancel',
    hasAffirm: 'confirmed',
    notAffirm: 'unconfirmed',
    uploadTimetext: 'Upload time',
    
    containerQueryTitle1: 'date',
    createContainerOrder: 'Update container information',
    arrivePort: 'Port of arrival',
    inspection: 'inspection',
    
    orderHistoryState: [{ value: '0', label: 'archived' }, { value: '1', label: 'deleted' }],
    
    addformalWorkersTitle: 'New permanent staff',
    updateformalWorkersTitle: 'Modify the permanent staff',
    // 保留货物管理
    placeholderKeyword: 'Please enter the keywords',
    placeholderColumn: 'Please select the search column',
    createCargoTable: '創建保留在庫表',
    deleteCargoTable: '削除保留在庫表',
    
		DriverAreaAll:'全部',
		DriverAreaTokyo:'東京',
		DriverAreaOsaka:'大阪',
    mainOrDeputyPlaceholder: 'Please enter the main order number/sub-order number',
    queryBtnText: 'Query',
    uploadBtnText: 'upload',
    signInTimeStartPlaceholder: 'Creation start time',
    signInTimeEndPlaceholder: 'End of creation time',
    amazonOrderStatus: 'Please select status',
    signInOrderStatus1: 'abnormal',
    signInOrderStatus2: 'normal',
    containerOrderLogisticsStatus: 'Please select logistics status',
    orderTemplateDialogTitle: 'Download the template',
    orderTemplateUploadTitle: 'upload',
    templateTypeTitle: 'Template type',
    specialTemplate: 'Special template',
    normalTemplate: 'General template',
    FCSpecialTemplate: 'FC Special template',
    batchUpdateLogisticsInfo: 'Set up logistics information',
    batchSetStatus: 'Setstate',
    batchDelete: 'Selete',
    createSignInImg: 'Create a receipt',
    signInImgName: 'Designation',
    signInOrderCustomer: 'The customer',
    uploadFileTitle: 'File',
    mainOrderNum: 'mark',
    deputyOrderNum: 'Cargo number',

    numInOrder: 'Number',
    addressInOrder: 'Address',
    estimatedTimeArrival: 'Take delivery time',
    uploadOrderFileError: 'File format error, please select again!',
    uploadOrderNoFileError: 'There is no content in the file!',
    checkLogisticsText: 'Check the logistics',
    goodsDescription: 'Description of goods',
    deliverySituation: 'Delivery situation',
    logisticsDate: 'Date and Time',
    setOrderStatus: 'setstate',
    orderStatusRemark: 'Descr',
    deliverySituation1: 'Already pick up the goods',
    deliverySituation2: 'In the distribution',
    deliverySituation3: 'Has been sent',
    deliverySituation4: 'Lift back to the warehouse',
    deliverySituation5: 'Refuse to accept',
    deliverySituation6: 'Once again to send',
    deliverySituation7: 'Not-updated',
    
    queryPlaceholder1: 'Please enter the sub-order number query', // main order number/
    queryPlaceholder2: 'Multiple orders are separated by ","',
    orderDetails: 'The order details',
    deliveryAddress: 'Delivery address',
    deliveryOrderTitle: 'Delivery Order',
    querySuborderTitle: 'Order no',
    delOrderLogisticsPrompt: 'This operation will permanently delete the logistics information. Do you wish to continue?'
  },
  ...enLocale
}

export default en